import React, { useState, useEffect } from "react";
import TripForm from "../../forms/TripForm";
import TripForm2 from "../../forms/TripForm2";
import "./StartNewTrip.scss";
import { connect } from "react-redux";
import { mapVtrStateToProps } from "../../services/mapStateToProps";
import {
  getOperatorOptions,
  getPermitOptions,
  TripEncRow,
  getShowCrewField,
  getShowAnglerField,
} from "../../constants/vtrTrip";
import { mapDispatchToProps } from "../../constants/dispatchNewTripForm";
import DefaultButton from "../../components/DefaultButton";
import { Navigate } from "react-router-dom";
import {
  validateNewTripSet1,
  validateNewTripSet2,
} from "../../constants/tripValidations";
import moment from "moment";
import { checkTripIdExist, createTripId } from "../../actions/newVtrTrip";
import { Box } from "@mui/material";
import { success, info } from "../../constants/colors";
import { OPEN_TRIP_RECORD } from "../../constants/TripStatus";
import Spinner from "../../components/common/Spinner";

function NewTrip({ auth, vtrTrip, helpText, ...props }) {
  const [currentStep, setCurrentStep] = useState(1);
  const [maximumStep] = useState(2);
  const [event_action, setEventAction] = useState(null);
  const [reviewed_trip, setReviewedTrip] = useState(false);
  const [currentType, setCurrentType] = useState("");
  const [report_type, setReportType] = useState("");
  const [trip_type, setTripType] = useState("");
  const [display_trip_type, setDisplayTripType] = useState("");
  const [number_of_crew, setNumberOfCrew] = useState("");
  const [number_of_anglers, setNumberOfAnglers] = useState("");
  const [showNrCrewField, setShowNrCrewField] = useState(false);
  const [showNrAnglersField, setShowNrAnglersField] = useState(false);
  const [vessel_permit_num, setVesselPermitNum] = useState("");
  const [vessel_registration, setVesselRegistration] = useState("");
  const [vessel_name, setVesselName] = useState("");
  const [operator_permit_number, setOperatorPermitNumber] = useState("");
  const [operator_first_name, setOperatorFirstName] = useState("");
  const [operator_middle_name, setOperatorMiddleName] = useState("");
  const [operator_last_name, setOperatorLastName] = useState("");
  const [operator_ext_name, setOperatorExtName] = useState("");
  const [vessel_permit_options, setVesselPermitOptions] = useState([]);
  const [operator_options, setOperatorOptions] = useState([]);
  const [display_date_sail, setDisplayDateSail] = useState(null);
  const [date_sail, setDateSail] = useState(null);
  const [no_effort_trip_reason] = useState("0");
  const [trip_id, setTripId] = useState(null);
  const [default_uom, setDefaultUOM] = useState("");
  const [default_species_uom, setDefaultSpeciesUom] = useState("");
  const {
    validations: {
      validations: { operator = [], permit = [], reportTripType = [] },
      loading,
      updating,
    },
  } = props;
  const { vessel_entitlements, operator_entitlements, client_id, vtr_preferences } = auth;
  const values = {
    currentStep,
    date_sail,
    display_date_sail,
    display_trip_type,
    default_uom,
    default_species_uom,
    event_action,
    maximumStep,
    no_effort_trip_reason,
    number_of_anglers,
    number_of_crew,
    operator_ext_name,
    operator_first_name,
    operator_middle_name,
    operator_last_name,
    operator_options,
    operator_permit_number,
    reviewed_trip,
    showNrAnglersField,
    showNrCrewField,
    trip_id,
    report_type,
    trip_type,
    vessel_name,
    vessel_permit_num,
    vessel_permit_options,
    vessel_registration,
  };

  const handleTripTypeChange = (event) => {
    event.preventDefault();
    let newTripType = event.target.value;
    const type = reportTripType.find((type) => type.KEY === parseInt(newTripType));
    if (type) {
      setCurrentType(type.KEY);
      setReportType(type.REPORT_TYPE);
      setTripType(String(type.TRIP_TYPE));
      showFields(type.TRIP_TYPE);
      setDisplayTripType(type.VALUE);
      setDefaultUOM(type.DEFAULT_UOM);
      setDefaultSpeciesUom(type.DEFAULT_SPECIES_UOM);
    }
  };

  const handleTripTypePreferenceChange = (event) => {
    event.preventDefault();
    let newTripType = event.currentTarget.dataset.newValue;
    const type = reportTripType.find((type) => type.KEY === parseInt(newTripType));
    if (type) {
      setCurrentType(type.KEY);
      setReportType(type.REPORT_TYPE);
      setTripType(String(type.TRIP_TYPE));
      showFields(type.TRIP_TYPE);
      setDisplayTripType(type.VALUE);
      setDefaultUOM(type.DEFAULT_UOM);
      setDefaultSpeciesUom(type.DEFAULT_SPECIES_UOM);
    }
  };

  const showFields = (newTripType) => {
    let showNrCrewField = getShowCrewField(newTripType);
    let showNrAnglersField = getShowAnglerField(newTripType);
    setShowNrCrewField(showNrCrewField);
    setShowNrAnglersField(showNrAnglersField);
  };

  const handleInputChange = (event) => {
    event.preventDefault();
    const value = event.target.value;
    const name = event.target.name;
    if (name === "number_of_crew") setNumberOfCrew(value);
    else if (name === "number_of_anglers") setNumberOfAnglers(value);
  };

  const _next = (event, value) => {
    event.preventDefault();
    console.group("StartNewTripNext");
    const { actions } = props;
    let errors1 = [];
    let errors2 = [];
    let eventAction = event.currentTarget.dataset.action;

    if (currentStep === 1) {
      errors1 = validateNewTripSet1(values);
    }
    let showAnglers = showNrAnglersField;
    let showCrew = showNrCrewField;

    if (currentStep === 2) {
      [showCrew, showAnglers, errors2] = validateNewTripSet2(values);
      console.log("error2", errors2);
    }

    let allErrors = errors1.concat(errors2);
    console.log("startNewTripSubmit", allErrors);
    actions.setError(allErrors);
    if (allErrors.length > 0) {
      console.groupEnd();
      return;
    }

    //Prepare operator and vessel Selection when clicking next button
    let operatorFirstName = "";
    let operatorMiddleName = "";
    let operatorLastName = "";
    let operatorExtName = "";
    let operatorKey = "";
    let vesselHull = vessel_registration;
    let vesselName = vessel_name;
    let vesselPermitNum = vessel_permit_num;

    let operatorOptions = operator_options || [];

    if ((currentStep === 1 && eventAction === "next_vtr") || currentStep > 1) {
      operatorOptions = getOperatorOptions(
        operator,
        vessel_entitlements,
        operator_entitlements,
        auth,
        vessel_permit_num
      );
      if (operatorOptions.length === 1) {
        operatorFirstName = operatorOptions[0].NAME_FIRST;
        operatorMiddleName = operatorOptions[0].NAME_MIDDLE;
        operatorLastName = operatorOptions[0].NAME_LAST;
        if (operatorOptions[0].hasOwnProperty("NAME_EXT")) {
          operatorExtName = operatorOptions[0].NAME_EXT;
        }
        operatorKey = operatorOptions[0].OPERATOR_KEY;
      }
    }

    let newTrip = new TripEncRow();
    newTrip.setNoEffortTripReason(no_effort_trip_reason);
    newTrip.setVesselName(vesselName);
    newTrip.setVesselRegistration(vesselHull);
    newTrip.setVesselPermitNum(vesselPermitNum);
    newTrip.setReportType(report_type);
    newTrip.setTripType(trip_type);
    newTrip.setDefaultUOM(default_uom);
    newTrip.setDefaultSpeciesUOM(default_species_uom);
    newTrip.setNumberOfAnglers(showAnglers ? number_of_anglers : "");
    newTrip.setNumberOfCrew(showCrew ? number_of_crew : "");
    newTrip.setOperatorFirstName(
      operatorFirstName ? operatorFirstName : operator_first_name
    );
    newTrip.setOperatorMiddleName(
      operatorMiddleName ? operatorMiddleName : operator_middle_name
    );
    newTrip.setOperatorLastName(operatorLastName ? operatorLastName : operator_last_name);
    newTrip.setOperatorExtName(operatorExtName ? operatorExtName : operator_ext_name);
    newTrip.setOperatorPermitNumber(operatorKey ? operatorKey : operator_permit_number);
    newTrip.setDateSail(date_sail);
    newTrip.setNumberOfCrew(number_of_crew);
    newTrip.setNumberOfAnglers(number_of_anglers);
    newTrip.setVesselPermitNum(vessel_permit_num);
    newTrip.setVesselName(vessel_name);
    newTrip.setVesselRegistration(vessel_registration);
    newTrip.setTripStatus(OPEN_TRIP_RECORD);

    setOperatorOptions(operatorOptions ? operatorOptions : []);
    if (operatorOptions.length === 1) {
      setOperatorFirstName(operatorFirstName);
      setOperatorMiddleName(operatorMiddleName);
      setOperatorLastName(operatorLastName);
      setOperatorExtName(operatorExtName);
      setOperatorPermitNumber(operatorKey);
    }

    if (currentStep === 1) {
      if (!trip_id) {
        if (vessel_permit_num && date_sail) {
          let newTripId = createTripId(null, display_date_sail, vessel_permit_num);
          let counter = 0;
          let tripIdExist = checkTripIdExist(newTripId, client_id);
          if (tripIdExist) {
            let newDateSail = display_date_sail;
            while (tripIdExist) {
              if (counter === 100) {
                let error = [];
                error[0] = "Not able to create new trip";
                actions.setError(error);
                event.stopImmediatePropagation();
                return;
              }
              // * This could be done on the createTripId method.
              newDateSail = moment(newDateSail, "DD-MMM-YY LT").add(1, "hour");
              newTripId = createTripId(newTripId, newDateSail, vessel_permit_num);
              tripIdExist = checkTripIdExist(newTripId, client_id);
              counter++;
            }
          }
          newTrip.setTripId(newTripId);
          newTrip.setNoEffortTripReason("0");
          actions.saveTrip(newTrip, client_id);
          setTripId(newTripId);
          setEventAction(eventAction);
        } else {
          let error = [];
          error[0] = "Not able to create tripId";
          actions.setError(error);
        }
      } else {
        actions.updateTrip(newTrip, client_id, trip_id);
      }
    }
    setCurrentStep(currentStep + 1);
    if (currentStep === maximumStep) {
      newTrip.setTripId(trip_id);
      actions.updateTrip(newTrip, client_id, trip_id);
      setReviewedTrip(true);
    }
    // * Ending console group
    console.groupEnd();
  };

  const _prev = (event) => {
    event.preventDefault();
    let step = currentStep <= 1 ? 1 : currentStep - 1;
    setCurrentStep(step);
  };

  useEffect(() => {
    if (loading === false && updating === false) {
      let vesselOptions = getPermitOptions(
        permit,
        vessel_entitlements,
        operator_entitlements,
        null
      );
      if (vesselOptions.length === 1) {
        setVesselPermitNum(vesselOptions[0].PNUM);
        setVesselRegistration(vesselOptions[0].HULL_ID);
        setVesselName(vesselOptions[0].VES_NAME);
      }
      setVesselPermitOptions(vesselOptions);
    }
  }, [loading, updating, vessel_entitlements, operator_entitlements, permit]);

  const handleSailDateChange = (date) => {
    if (date && date.hasOwnProperty("_d")) {
      let newDateTime = date._d;
      if (newDateTime !== "") {
        let bDateTime = moment(newDateTime, "DD-MM-YYYY LT").format("YYMMDDHHmm");
        setDisplayDateSail(newDateTime);
        setDateSail(bDateTime);
      } else {
        setDisplayDateSail(newDateTime);
        setDateSail("");
      }
    }
  };

  const sailDateNowHandler = (event) => {
    event.preventDefault();
    let d = moment();
    const format = "DD-MMM-YY LT";
    let newState = {};
    newState.date_sail = d.format("YYMMDDHHmm");
    newState.display_date_sail = d.format(format);
    setDateSail(newState.date_sail);
    setDisplayDateSail(newState.display_date_sail);
  };

  const handleTripPermitPreferenceChange = (event) => {
    event.preventDefault();
    let { pnum, hullId, vesName, field } = event.currentTarget.dataset;

    if (!pnum) {
      console.log("No vessel permit value provided");
      return;
    }
    if (!field) {
      console.error("No field provided");
      return;
    }
    setVesselName(vesName);
    setVesselRegistration(hullId);
    setVesselPermitNum(pnum);
  };

  const handleTripOperatorPreferenceChange = (event) => {
    event.preventDefault();
    let { operatorKey, nameFirst, nameMiddle, nameLast, nameExt, field } =
      event.currentTarget.dataset;

    if (!operatorKey) {
      console.log("No vessel operator value provided");
      return;
    }
    if (!field) {
      console.error("No field provided");
      return;
    }

    setOperatorPermitNumber(operatorKey);
    setOperatorFirstName(nameFirst);
    setOperatorMiddleName(nameMiddle);
    setOperatorLastName(nameLast);
    setOperatorExtName(nameExt);
    console.info(
      "prefOperatorchange",
      operator_permit_number,
      operator_first_name,
      operator_middle_name,
      operator_last_name,
      operator_ext_name
    );
  };

  const handleOperatorChange = (event, reason) => {
    event.preventDefault();
    if (reason) {
      if (
        reason.hasOwnProperty("OPERATOR_KEY") &&
        reason.hasOwnProperty("NAME_FIRST") &&
        reason.hasOwnProperty("NAME_MIDDLE") &&
        reason.hasOwnProperty("NAME_LAST")
      ) {
        setOperatorPermitNumber(reason.OPERATOR_KEY);
        setOperatorFirstName(reason.NAME_FIRST);
        setOperatorMiddleName(reason.NAME_MIDDLE);
        setOperatorLastName(reason.NAME_LAST);
        if (reason.hasOwnProperty("NAME_EXT")) {
          setOperatorExtName(reason.NAME_EXT);
        }
      }
    } else {
      setOperatorPermitNumber("");
      setOperatorFirstName("");
      setOperatorMiddleName("");
      setOperatorLastName("");
    }
  };

  const handleTripPreferenceChange = (event) => {
    event.preventDefault();
    let newValue = event.currentTarget.dataset.newValue;
    let field = event.currentTarget.dataset.field;
    if (!newValue) {
      console.log("No new value provided");
      return;
    }
    if (!field) {
      console.error("No field provided");
      return;
    }
    if (field === "number_of_crew") setNumberOfCrew(newValue);
    else if (field === "number_of_anglers") setNumberOfAnglers(newValue);
  };

  const handlePermitChange = (event, reason) => {
    event.preventDefault();
    if (reason) {
      //Save the new values when selected
      if (
        reason.hasOwnProperty("PNUM") &&
        reason.hasOwnProperty("HULL_ID") &&
        reason.hasOwnProperty("VES_NAME")
      ) {
        setVesselPermitNum(reason.PNUM);
        setVesselRegistration(reason.HULL_ID);
        setVesselName(reason.VES_NAME);
      }
    } else {
      //If emptied then empty the state
      setVesselPermitNum("");
      setVesselRegistration("");
      setVesselName("");
    }
  };

  if (vtrTrip.redirect === true) {
    if (currentStep > maximumStep && reviewed_trip === true) {
      return (
        <Navigate
          replace
          to={`${process.env.PUBLIC_URL}/vtr-trip-review`}
          state={{
            trip_id: vtrTrip.trip_id,
            client_id: client_id,
          }}
        />
      );
    }
    if (event_action === "next_ivr") {
      return (
        <Navigate
          replace
          to={`${process.env.PUBLIC_URL}/ivr`}
          state={{
            trip_id: vtrTrip.trip_id,
            vesselNbr: vessel_permit_num,
          }}
        />
      );
    }
  }

  if (loading === true || updating === true || vessel_permit_options.length === 0) {
    return (
      <div>
        <Spinner />
      </div>
    );
  }

  return (
    <div style={{ width: "100%", marginBottom: "70px" }}>
      <Box display="flex" justifyContent="center" flex={1} flexDirection="column">
        <TripForm
          helpText={helpText.helpText}
          currentStep={currentStep}
          preferences={vtr_preferences}
          handleSailDateChange={handleSailDateChange}
          display_date_sail={display_date_sail}
          handleTripPreferenceChange={handleTripPreferenceChange}
          sailDateNowHandler={sailDateNowHandler}
          handlePermitChange={handlePermitChange}
          vessel_permit_options={vessel_permit_options}
          vessel_permit_num={vessel_permit_num}
          vessel_name={vessel_name}
          vessel_registration={vessel_registration}
          handleTripPermitPreferenceChange={handleTripPermitPreferenceChange}
        />
        <TripForm2
          helpText={helpText.helpText}
          handleChange={handleTripTypeChange}
          handleInputChange={handleInputChange}
          number_of_crew={number_of_crew}
          number_of_anglers={number_of_anglers}
          showNrCrewField={showNrCrewField}
          showNrAnglersField={showNrAnglersField}
          currentType={currentType}
          types={reportTripType}
          currentStep={currentStep}
          preferences={vtr_preferences}
          handleTripTypePreferenceChange={handleTripTypePreferenceChange}
          handleTripPreferenceChange={handleTripPreferenceChange}
          handleOperatorChange={handleOperatorChange}
          operator_options={operator_options}
          operator_permit_number={operator_permit_number}
          operator_first_name={operator_first_name}
          operator_middle_name={operator_middle_name}
          operator_last_name={operator_last_name}
          operator_ext_name={operator_ext_name}
          handleTripOperatorPreferenceChange={handleTripOperatorPreferenceChange}
        />
      </Box>
      {currentStep !== 1 && (
        <Box display="flex" justifyContent="center" m={1} p={1}>
          <Box p={1}>
            <DefaultButton changeHandler={_prev} buttonText={"Back"} />
          </Box>
          <Box p={1}>
            <DefaultButton
              changeHandler={_next}
              buttonText={currentStep === maximumStep ? "Save" : "Next"}
              action={"next_vtr"}
              bgColor={currentStep === maximumStep ? success : ""}
            />
          </Box>
        </Box>
      )}
      {currentStep === 1 && (
        <Box display="flex" justifyContent="center" m={1} p={1}>
          <Box p={1}>
            <DefaultButton
              changeHandler={_next}
              buttonText={"Additional Reports"}
              action={"next_ivr"}
              bgColor={info}
            />
          </Box>
          <Box p={1}>
            <DefaultButton
              changeHandler={_next}
              buttonText={"Next"}
              action={"next_vtr"}
            />
          </Box>
        </Box>
      )}
    </div>
  );
}

export default connect(mapVtrStateToProps, mapDispatchToProps)(NewTrip);
